import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../../custom/dataTable';
import Edit from '../../../../../assets/img/svg/edit.svg';
import Delete from '../../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../../assets/img/svg/FilterIcon.svg';
import del from "../../../../../assets/img/svg/Del.svg"
import View from "../../../../../assets/img/svg/view.svg"
import Autocomplete from "react-autocomplete"
import $ from "jquery"
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import { Tabs, Tab, AppBar, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from "../../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Save from '../../../../../assets/img/svg/save.svg';
import Cancel from '../../../../../assets/img/svg/cancel.svg';
import moment from 'moment'
import upload from '../../../../../assets/img/svg/upload.svg';
import active from '../../../../../assets/img/svg/active.svg';
import deactive from '../../../../../assets/img/svg/deactive.svg';
import { getSettingsFormat } from "../../../../../actions/SettingsAction";
import { getprojectdisprodocinfo } from "../../../../../actions/DismantlingAction";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import axios from "axios";
import API from "../../../../../_helpers/endpointService";
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import EasyEdit from 'react-easy-edit';
import { CssTextField, CssTextFieldLast, CssTextFieldTitle } from "../../../../custom/textField"

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

class ListViewDISPRO extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            value: 0,
            titleShow: true,
            Dispro_ListView: [],
            Description: [],
            Delete: [],
            Docs: {},
            index:1,
            hide: 0,
            UserRole: "",
            linkValue: 0,
            DrawingData: {
                Title: "",
                ProjectId: 0,
                Id: 0,
                Modify: ""
            },
            filename: "",
            awsname: "",
            searchData: {
                Description: "",
                DateTimeFrom: "",
                DateTimeTo: "",
                PageNumber: 1,
                PageSize: 10,
                SortBy: 'date',
                SortOrder: 'asc'
            },
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        // this.state.searchData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.DrawingData.ProjectId = localStorage.getItem("DashId");
        this.state.DrawingData.Modify = localStorage.getItem("UserRoles");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.linkValue = parseInt(localStorage.getItem("Dis"));
        this.setState({})
        if (this.state.linkValue) {
            this.setState({
                value: this.state.linkValue
            })
        }
        else {
            localStorage.setItem("Dis", 0)
            this.setState({
                value: 0
            })
        }
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId)
        this.Drawing(this.state.ProjectId)
        this.getprojectshipinfo(localStorage.getItem("DashId"))
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    getprojectshipinfo = (data) => {
        let apiUrl = API.ADDEDIT_SHIPINFO + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.LightShipWeight > 0) {
                        localStorage.setItem("LightshipWeight", response?.data?.LightShipWeight);
                    }
                    else{
                        localStorage.setItem("LightshipWeight", 0);
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        if (!window.location.pathname.includes('dismantlingprogress')) {
            localStorage.removeItem("Dis")
        }
        $("#DISPR1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dispro1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dispro").addClass("d-none");
        $("#Dispro").removeClass("d-block");
        $("#DISPL").removeClass("active-color");
        $("#DISPT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        this.state.Dispro_ListView = this.props.Dispro_ListView;
        this.setState({})
    };
    resize1 = () => {
        $("#DISPR1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dispro1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dispro").removeClass("d-none");
        $("#Dispro").addClass("d-block");
        $("#DISPL").addClass("active-color");
        $("#DISPT").addClass("fw-bolder");
    }
    getSettingsFormat = (data) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTable = (data, id) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '?projectId=' + id + '&Description=' + data.Description + '&DateTimeFrom=' + data.DateTimeFrom + '&DateTimeTo=' + data.DateTimeTo +'&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;

        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    destroyDataTable("staffTable");
                    if (response.data.Dismantling.length > 0) {
                        response.data.Dismantling.map((i) => {
                            if (i.Description != null && i.Description != undefined && i.Description != "") {
                                this.state.Description.push(i.Description)
                            }
                        })
                    }
                    this.props.dispatch({ type: "DISPRO_DOCS", data: response.data })
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? true : false }, { type: 'day', targets: [1] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder]);
                    this.setState({})
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    Drawing = (id) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/Drawing/' + id;

        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.DrawingData.Title = response.data.Title;
                    this.state.DrawingData.Id = response.data.Id;
                    if (response.data.Drawing) {
                        this.state.Docs = {
                            FileName: response.data.Drawing.FileName,
                            ObjectKey: response.data.Drawing.ObjectKey,
                            AwsFolderName: response.data.Drawing.AwsFolderName,
                            AwsUniqueFileName: response.data.Drawing.AwsUniqueFileName,
                            FileExtention: response.data.Drawing.FileExtention,
                            FileUrl: response.data.Drawing.FileUrl,
                            FileSize: response.data.Drawing.FileSize,
                        }
                    }
                    this.setState({})
                    if (this.state.DrawingData.Title != '') {
                        this.setState({ titleShow: false })
                    }
                    else {
                        this.setState({ titleShow: true })
                    }


                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }
    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    handleInputChangeTable = (e, str) => {
        this.state.searchData[str] = e.target.value;
        this.setState({})
    };

    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dismantlingprogress/addnew")
    };

    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dismantlingprogress/edit")
    };

    ViewPage = () => {
        this.props.navigate("/dismantlingprogress/view")
    };
    ViewPageLink = (id) => {
        localStorage.setItem("DISPROEditId", id)
        this.props.navigate("/dismantlingprogress/view")
    };

    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        localStorage.setItem("Dis", newValue)
        if (newValue == 1) {
            this.props.dispatch({ type: "SHOW_LOADER", data: true })
            this.dataTable(this.state.searchData, this.state.ProjectId)
        }
        else {
            this.Drawing(this.state.ProjectId)
        }
    };

    handleProjectNameSearchChange = (e) => {
        this.state.searchData.Description = e.target.value;
        this.setState({});
    };

    handleProjectNameSelectChange = (e) => {
        this.state.searchData.Description = e;
        this.setState({});
    };

    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            Description: "",
            DateTimeFrom: "",
            DateTimeTo: "",
            PageNumber: 1,
            PageSize: 10,
            SortBy: 'date',
            SortOrder: 'asc'
        };
        this.state.searchData = input;
        this.setState({});
        // this.dataTable(this.state.searchData, this.state.ProjectId);
        // dispatch(getprojectdisprodocinfo(this.state.searchData, this.state.ProjectId))
    };

    filterSearch() {
        const { dispatch } = this.props;
        this.state.index=1;
        this.state.searchData.SortBy='date'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        // this.dataTable(this.state.searchData, this.state.ProjectId);
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId)
    };

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId)
    }

    DeleteItem = () => {
        let tempData = [];
        const { Delete } = this.state;
        window.$("#deletepopup").modal("hide");
        this.deletemulitidisprodocs(Delete, this.state.UserRole)
        this.state.hide = 0;
        this.setState({});
        $('input[type=checkbox]').prop('checked', false);

        //this.props.dispatch(getprojectdisprodocinfo(temp, this.state.ProjectId))
    }

    deletemulitidisprodocs = (data, name) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }

        let apiUrl = API.DISMANTLING_PROGRESS + '/ids?' + ids + '&modify=' + name;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.Delete = [];
                    this.state.searchData = {
                        Description: "",
                        DateTimeFrom: "",
                        DateTimeTo: "",
                        PageNumber: 1,
                        PageSize: 10,
                        SortBy: 'date',
                        SortOrder: 'asc'
                    };
                    this.setState({})
                    // this.props.navigate(`/dismantlingprogress`)
                    this.dataTable(this.state.searchData, this.state.ProjectId);

                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    handleCheckbox = (e, x) => {
        const { Delete } = this.state;
        if (Delete.length == 0) {
            Delete.push(x)
        }
        else {
            if (Delete.filter((i) => i == x).length == 1) {
                Delete.map((i, ind) => (
                    i == x ?
                        Delete.splice(ind, 1)
                        : ""
                ))
            } else {
                Delete.push(x)
            }
        }
        this.setState({})
        if (Delete.length == 1) {
            localStorage.setItem("DISPROEditId", Delete[0])
        }

        this.state.hide = Delete.length;
        this.setState({})

    };

    OpenPopup = (filename, awsname) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        // this.state.Id = id;
        this.setState({})
        window.$("#deletepopup1").modal("show");
    }

    UploadFile = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                fileName: a.name,
                size: a.size,
                check: false,
                fdata: a,
                base64: await this.toBase64(a),
            }
            this.state.Docs = upload;
            this.setState({})
            this.AddSave();
        })
    };

    setCheckbox = (str) => {
        this.state.Docs.map((i) => {
            if (str == i.fileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    DeleteItem1 = () => {
        if (this.state.Docs.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
            this.deletePhoto(this.state.DrawingData.Id, this.state.awsname)
        }
        window.$("#deletepopup1").modal("hide");
    }
    deletePhoto = (id, filename) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/id?id=' + id + '&filename=' + filename
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.Drawing(this.state.ProjectId)
                    this.state.Docs = {}
                    this.setState({})
                    this.props.navigate("/dismantlingprogress")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    AddCancel = () => {
        this.state.value = 0;
        this.setState({})
        let temp = {
            Description: "",
            DateTimeFrom: "",
            DateTimeTo: "",
            PageNumber: 1,
            PageSize: 10,
        }
        this.dataTable(temp, this.state.ProjectId)
    }
    // saveTitle = (value) => {
    //     this.state.DrawingData.Title = value;
    //     this.setState({})
    //     if (this.state.DrawingData.Id == 0) {
    //         this.PostTitle(this.state.DrawingData)
    //     }
    //     else {
    //         this.PutTitle(this.state.DrawingData, this.state.DrawingData.Id)
    //     }
    // }
    handleInputChange1 = (e) => {
        this.state.DrawingData.Title = e.target.value;
        this.setState({})
    }
    handleInputChange = (e) => {

        this.state.DrawingData.Modify = localStorage.getItem("UserRoles");
        this.setState({});
        if (this.state.DrawingData.Id == 0) {
            if (this.state.DrawingData.Title != "") {
                this.state.titleShow = false;
                this.state.DrawingData.Title = e.target.value.trim();
                this.PostTitle(this.state.DrawingData)
            }
            else {
                this.setState({
                    titleShow: true
                })
            }
        }
        else {
            this.state.DrawingData.Modify = localStorage.getItem("UserRoles");
            this.setState({});
            if (e.target.value.trim() != '') {
                this.state.titleShow = false;
                this.state.DrawingData.Title = e.target.value.trim();
                this.setState({});
                this.PutTitle(this.state.DrawingData, this.state.DrawingData.Id)
            }
            else {
                this.state.DrawingData.Title = e.target.value.trim();
                this.setState({})
                this.PutTitle(this.state.DrawingData, this.state.DrawingData.Id)
                this.setState({
                    titleShow: true
                })
            }
        }
        this.setState({})
    }
    PostTitle = (data) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/Drawing';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.Drawing(this.state.ProjectId)
                    this.props.navigate("/dismantlingprogress")
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    PutTitle = (data, id) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/id?id=' + id;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.Drawing(this.state.ProjectId)
                    this.props.navigate("/dismantlingprogress")
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    AddSave = () => {
        if (Object.keys(this.state.Docs).length != 0) {
            let formData = new FormData()
            formData.append("drawing", this.state.Docs.fdata)
            this.adddprofileinfo(formData, this.state.DrawingData.Id)
        }

    }

    adddprofileinfo = (data, id) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/id?id=' + id;

        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.Drawing(this.state.ProjectId)
                    this.props.navigate("/dismantlingprogress")

                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };
    handleSort = (data,ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber=1
        this.setState({
            index:ind
        });
        this.dataTable(this.state.searchData, this.state.ProjectId);

    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"DISPR" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="DISPR" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Dismantling Progress</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? this.state.value == 1 ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                            <div className="row  border-bottom">
                                <div className="input-group">
                                    {this.state.value == 1 ? <>
                                        <div className={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? "col-3 col-sm-3 border-right text-center pt-3" : "col-3 col-sm-3 border-right text-center pt-3 pb-3"} style={{ whiteSpace: 'nowrap' }}>
                                            <span className={`${classes.button} ${this.state.hide == 1 ? "span-enabled" : "span-disabled"}`} onClick={this.ViewPage} style={{ minWidth: '70px' }}><img src={View} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;View</span>
                                        </div>

                                        <div className="col-3 col-sm-3 border-right text-center pt-3 pl-2" style={{ whiteSpace: 'nowrap' }}>
                                            <span className={`${classes.button} ${this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide == 1 ? "span-enabled" : "span-disabled" : "span-disabled"}`} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</span>
                                        </div>
                                        <div className="col-3 col-sm-3 border-right text-center pt-3 pl-2" style={{ whiteSpace: 'nowrap' }}>
                                            <span className={`${classes.button} ${this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide > 0 ? "span-enabled" : "span-disabled" : "span-disabled"}`} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</span>
                                        </div>
                                        <div className="col-3 col-sm-3 pt-3  text-center pb-3 pl-1" style={{ whiteSpace: 'nowrap' }}>
                                            <span className={`${classes.button} ${this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? "span-enabled" : "span-disabled"}`} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? '' : '0.5' }}></i>Add New</span>
                                        </div>
                                    </> : <></>}

                                </div>
                            </div>
                        </> : <>

                        </>
                        :
                        <>{this.state.value == 1 ?
                            this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                <div className="row  border-bottom">
                                    <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3 d-flex" style={{ height: "50px" }}>
                                        <button className={`${classes.button} pl-3`} disabled={this.state.hide == 1 ? false : true} onClick={this.ViewPage} style={{ minWidth: '70px' }}><img src={View} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;View</button>

                                        <button className={classes.button} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide == 1 ? false : true : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                        <button className={`${classes.button}`} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.hide > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</button>
                                        <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                            <button className={classes.button} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? false : true} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? '' : '0.5' }}></i>Add New</button>
                                        </div>

                                    </div>
                                </div>
                            </> : <></>
                            :
                            <>

                            </>
                        }
                        </>}
                    <div>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3">Dismantling Progress</h6>}
                    </div>
                    <div className="row">
                        <div>
                            <AppBar position="static" color="inherit" className={classes.root} style={{ margin: '0', maxHeight: '0px' }}>
                                <Tabs
                                    value={this.state.value}
                                    onChange={this.handleChange}
                                    classes={{ indicator: classes.indicator }}
                                >
                                    <Tab className="f-size-12 ml-3" style={{ textTransform: "none", minWidth: '13px' }} label="Profile View" {...a11yProps(0)} />
                                    <Tab className="f-size-12 " style={{ textTransform: "none", minWidth: '13px' }} label="Dismantling Progress" {...a11yProps(1)} />
                                </Tabs>
                            </AppBar>
                            <TabPanel value={this.state.value} index={1}>
                                <div className="row mt-2" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                                    <div className="col-12 py-2 px-0 text-right mt-2">
                                        <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }}><img src={FilterIcon} />&nbsp;Filter</button>
                                    </div>
                                    <div className={this.state.isMobile ? "col-12 px-2" : "col-12 px-0"}>
                                        <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                            <table id="staffTable" className="dataTable">
                                                <thead>
                                                    <tr className="">
                                                        <th className="border-top align-middle border-left" width="3%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                                        <th className="border-right border-top border-left" width="8%" style={{ minWidth: '70px' }} onClick={() => this.handleSort('date',1)}><span className="spandoc-thead" style={{ color: "#000000" }}>Date</span></th>
                                                        <th className="border-right border-top" style={{ minWidth: '600px' }} onClick={() => this.handleSort('description',2)}><span className="spandoc-thead" style={{ color: "#000000" }}>Description</span></th>
                                                        <th className="border-right border-top" width="10%" style={{ minWidth: '70px', whiteSpace: 'nowrap' }} onClick={() => this.handleSort('dismantledtons',3)}><span className="spandoc-thead" style={{ color: "#000000" }}>Dismantled Tons</span></th>
                                                        <th className="border-right border-top" width="10%" style={{ minWidth: '70px', whiteSpace: 'nowrap' }} onClick={() => this.handleSort('dismantledpercentage',4)}><span className="spandoc-thead" style={{ color: "#000000" }}>% Dismantled</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.Dispro_ListView?.Dismantling && this.props.Dispro_ListView?.Dismantling.map((i) => {
                                                        return (
                                                            <tr>
                                                                <td className="spandoc-td align-middle border-left"><input type="checkbox" style={{ width: "16px", height: "16px" }} checked={this.state.Delete.filter(r=> r === i.Id).length == 1 ? true : false} onChange={(e) => { this.handleCheckbox(e, i.Id) }} /></td>
                                                                <td className="spandoc-td border-right border-left align-middle spandoc-td">{i.Date && moment(i.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                                <td className="spandoc-td border-right align-middle"><span className="spandoc-td">
                                                                    <a href="#" onClick={() => this.ViewPageLink(i.Id)}>{i.Description}</a></span>
                                                                </td>
                                                                <td className="spandoc-td border-right align-middle text-right"><span className="spandoc-td">{i.DismantledTons}</span></td>
                                                                <td className="spandoc-td border-right align-middle text-right"><span className="spandoc-td">{i.DismantledTonsPercentage}</span></td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel value={this.state.value} index={0}>
                                <div className="row mt-4">

                                    <div className="row px-1 mx-0" style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                                        <div className="row px-2 mx-0">
                                            {this.state.titleShow ? <>
                                                <div className="mt-3 px-0" style={{ width: '58px' }}>
                                                    <span className="mr-3 spandoc-thead">Title :</span>
                                                </div>
                                                <div className={this.state.isMobile ? "col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mt-2 px-0 pb-1" : this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? "col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mt-2 " : "col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mt-2 pb-3"}>
                                                    {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            onChange={(e) => this.handleInputChange1(e)}
                                                            onBlur={(e) => this.handleInputChange(e)}
                                                            value={this.state.DrawingData.Title}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody spanTopBar ${classes.inputfieldAlign}`
                                                            }} />
                                                    </> : <>
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            disabled
                                                            value={this.state.DrawingData.Title}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody spanTopBar ${classes.inputfieldAlign}`
                                                            }} /></>}
                                                </div>
                                            </> : <>
                                                <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 px-0 mx-n2">
                                                    <span className="fw-bold">
                                                        {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                onChange={(e) => this.handleInputChange1(e)}
                                                                onBlur={(e) => this.handleInputChange(e)}
                                                                value={this.state.DrawingData.Title}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody spanTopBar ${classes.inputfieldAlign}`
                                                                }} />
                                                        </> : <>
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                disabled
                                                                value={this.state.DrawingData.Title}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody  spanTopBar ${classes.inputfieldAlign}`
                                                                }} />
                                                        </>}
                                                    </span>
                                                </div>
                                            </>}
                                            {
                                                Object.keys(this.state.Docs).length == 0 ? <>
                                                    <div className="row mt-3 px-0">
                                                        <div className="d-flex">
                                                            <span className="pr-3 mr-0 spandoc-thead">Drawing&nbsp;:</span>
                                                            <button className="pending-button " style={{ marginRight: '5px' }}><h1 style={{ fontSize: '11px' }}>PENDING</h1></button>
                                                            {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                                <img src={upload} className="pl-2 mr-1" style={{ width: 23, height: 23, marginTop: '-4px', opacity: this.state.titleShow == false ? '' : '0.5' }} />
                                                                <button className={`${classes.button} pl-0`} style={{ marginTop: '-4px'}} disabled={this.state.titleShow == false ? false : true} onChange={(e) => this.UploadFile(e)} onClick={this.AttachFiles}>Upload</button>
                                                            </> : <>
                                                            </>}
                                                            <input
                                                                type="file"
                                                                hidden
                                                                onChange={(e) => this.UploadFile(e)}
                                                                ref={this.inputFile}
                                                            />

                                                            {/* <img className="img-fluid m-2" src={Ship}></img> */}
                                                        </div>
                                                    </div></> : <>
                                                    <div className="text-right pb-1 px-0">
                                                        {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(this.state.Docs.FileName, this.state.Docs.AwsUniqueFileName) }} />
                                                        </> : <></>}
                                                    </div>
                                                    <div className="col-12 px-0 text-row text-center pb-2 pt-2">
                                                        <img className="img-fluid px-2" src={this.state.Docs.FileUrl}></img>
                                                    </div>
                                                </>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        </div>
                    </div>

                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Description</label></div>
                                            <div className="col-7">

                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth

                                                    placeholder="Description"
                                                    value={this.state.searchData.Description}
                                                    onChange={(e) => { this.handleInputChangeTable(e, "Description") }}
                                                    InputProps={{
                                                        className: "border-radius"
                                                    }}
                                                />


                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    fullWidth
                                                    type="date"
                                                    id="type-date1"
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    value={this.state.searchData.DateTimeFrom && moment(this.state.searchData.DateTimeFrom).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.DateTimeFrom && moment(this.state.searchData.DateTimeFrom).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleInputChangeTable(e, "DateTimeFrom") }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    value={this.state.searchData.DateTimeTo && moment(this.state.searchData.DateTimeTo).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.DateTimeTo && moment(this.state.searchData.DateTimeTo).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleInputChangeTable(e, "DateTimeTo") }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="row text-center mt-4">
                                            <div className="col-2"></div>
                                            <div className="col-5" data-dismiss="modal">
                                                <button type="button" className="btn input-group border-radius f-size-13 filter-btn" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.filterSearch()}>Search</button>
                                            </div>
                                            <div className="col-5" data-dismiss="modal">
                                                <button type="button" id="closemodal" className="btn btn-light input-group border-radius f-size-13 filter-btn" >Cancel</button>
                                            </div>
                                        </div> */}
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.filterSearch()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem1()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopup1").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                {/* {
                    this.state.value == 1 ? <>
                        <div className={`${classes.pagination}`}>
                            <div className={`${classes.paginationItem}`}>
                                {this.state.searchData.PageNumber == 1 ? <></> :
                                    <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                                <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                                {(this.state.searchData.PageNumber == this.state.Dispro_ListView?.pagination?.PageCount) || (this.state.Dispro_ListView?.pagination?.PageCount == 0) ? <></> :
                                    <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                            </div>
                        </div> </>

                        : <></>
                } */}
                {
                    this.state.value == 1 ?
                        <div className={`${classes.pagination}`}>
                            <div className={`${classes.paginationItem}`}>
                                {this.state.searchData.PageNumber === 1 ? <></> :
                                    <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                                <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                                {(this.state.searchData.PageNumber === this.props.Dispro_ListView?.pagination?.PageCount) || (this.props.Dispro_ListView?.pagination?.PageCount == 0) ? <></> :
                                    <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                            </div>
                        </div>
                        : <></>
                }

            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Dispro_ListView: state.DismantlingReducer.Dispro_ListView,
        settings: state.commonReducer.settings || [],
    };
}

ListViewDISPRO.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewDISPRO))
);
